import { Autocomplete, Chip, InputAdornment, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterNonBrandOpportunity } from 'src/context/reducers/filter-settings/filterSlice';
import { RootState } from 'src/context/store';
import { useLocales } from 'src/locales';
import { opportunityFilterOptions } from './data-grid/opportunity-options';
import './_style.scss';

const ALL_CHIP_SX = { fontSize: '13px', backgroundColor: 'rgba(145, 158, 171, 0.12)', color: 'rgba(51, 60, 71, 1)' };

/** Header pill of Non Brand Search Performance: restricts the KPI cards, charts and grid to one opportunity type. */
export default function OpportunityFilterPill() {
  const { t } = useLocales();
  const dispatch = useDispatch();
  const selected = useSelector((state: RootState) => state.filters.nonBrandOpportunity);
  const options = opportunityFilterOptions(t);
  const value = options.find((option) => option.value === selected) ?? null;
  const select = (next: string | null) => dispatch(setFilterNonBrandOpportunity(next));

  return (
    <Autocomplete
      size="small"
      options={options}
      value={value}
      isOptionEqualToValue={(option, current) => option.value === current.value}
      getOptionLabel={(option) => option.label}
      onChange={(_, next) => select(next?.value ?? null)}
      // Four options, picked from the list: the field takes no input (typed text would filter unseen)
      filterOptions={(list) => list}
      disableClearable={!value}
      sx={{
        width: 240,
        '& .MuiAutocomplete-inputRoot': { flexWrap: 'nowrap', height: '36px', paddingTop: 0, paddingBottom: 0 },
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          <Chip className={`opportunity-chip opportunity-chip-${option.value}`} label={option.label} size="small" variant="soft" />
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          // The selection is shown as a chip, not as input text
          inputProps={{ ...params.inputProps, value: '', readOnly: true }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start" sx={{ ml: 0.5 }}>
                {value ? (
                  <Chip
                    className={`opportunity-chip opportunity-chip-${value.value}`}
                    label={value.label}
                    size="small"
                    variant="soft"
                    onDelete={() => select(null)}
                  />
                ) : (
                  <Chip label={t('dashboard.filters.all_opportunities')} size="small" variant="soft" sx={ALL_CHIP_SX} />
                )}
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
